import { useState } from "react";
import {jsx, css} from '@emotion/react';
import Modal from "../Modal";
import styles from './styles.jsx';
import styles_utilities from './styles_utilities.jsx';
import {HeaderIcon} from './utilities.jsx';
import CTAButton from '../CTAButton';
import {connectLocation} from "../location/LocationConnectors";

const highlights = css`
  ${styles.splash.highlights};
  p { margin-left: 35px !important; }
  li {margin: 0 0 15px}
`
const header = css`
display: flex;
font-family: 'Oswald';
font-weight: 700;
font-size: 21px;
line-height: 28px;
align-items: center;;
color: black;
text-transform: uppercase;
img { margin-left: 0 !important; margin-right: 5px !important; }
`
const spacer = css`
height: 20px;
`

const XWelcomeModal = ({t}) => {
  const [open, changeOpen] = useState(true);
  return (
    <Modal open={open} onClose={() => changeOpen(false)}>
      <p className="h3">{t('build_your_roof.byr_welcome')}</p>
      <div css={styles.splash.hero}>
        <p>{t('build_your_roof.splash_copy2')}</p>
        <p>{t('build_your_roof.splash_copy1')}</p>

        <ul css={highlights}>
          <li>
            <HeaderIcon cssOverride={header} what="seal"/>
            <p>{t('build_your_roof.splash_seal_copy')}</p>
          </li>
          <li>
            <HeaderIcon cssOverride={header} what="defend"/>
            <p>{t('build_your_roof.splash_defend_copy')}</p>
          </li>
          <li>
            <HeaderIcon cssOverride={header} what="breathe"/>
            <p>{t('build_your_roof.splash_breathe_copy')}</p>
          </li>
        </ul>
        <CTAButton data-track="tool-start" onClick={() => changeOpen(false)}>{t('build_your_roof.build_your_roof_cta')}</CTAButton>
        <div css={spacer}/>
        <p className="disclaimers">{t('build_your_roof.tprs_disclaimer')}</p>
      </div>
    </Modal>
  )
}
export const WelcomeModal = connectLocation(XWelcomeModal);
